/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import InfantIcon from '../../../../../../graphics/icons/InfantIcon.vue';
import ToddlerIcon from '../../../../../../graphics/icons/ToddlerIcon.vue';
import PreschoolIcon from '../../../../../../graphics/icons/PreschoolIcon.vue';
import ElementaryIcon from '../../../../../../graphics/icons/ElementaryIcon.vue';
import MiddleSchoolIcon from '../../../../../../graphics/icons/MiddleSchoolIcon.vue';

interface AgeGroupsDetail {
  value: string;
  optionText: string;
}

interface AgeGroupToggleTokenDetail {
  type: string;
  formattedText: string;
  icon: any;
}

enum ChildCareAgeGroups {
  FIRST_YEAR = 'FIRST_YEAR',
  TODDLERS = 'TODDLERS',
  PRESCHOOLERS = 'PRESCHOOLERS',
  GRADE_SCHOOL_AGE = 'GRADE_SCHOOL_AGE',
  PRE_TEEN_TEENAGERS = 'PRE_TEEN_TEENAGERS',
}

enum CompanionCareAgeGroups {
  UNDER_55 = 'UNDER_55',
  FROM_55_TO_64 = 'FROM_55_TO_64',
  FROM_65_TO_74 = 'FROM_65_TO_74',
  FROM_75_TO_84 = 'FROM_75_TO_84',
  OVER_85 = 'OVER_85',
}

type ChildCareAgeGroupsOptions = {
  [key in ChildCareAgeGroups]: AgeGroupsDetail;
};

type CompanionCareAgeGroupsOptions = {
  [key in CompanionCareAgeGroups]: AgeGroupsDetail;
};

const childCareAgeGroupsOptions: ChildCareAgeGroupsOptions = {
  [ChildCareAgeGroups.FIRST_YEAR]: {
    value: ChildCareAgeGroups.FIRST_YEAR,
    optionText: 'Infant (age 0-11 months)',
  },
  [ChildCareAgeGroups.TODDLERS]: {
    value: ChildCareAgeGroups.TODDLERS,
    optionText: 'Toddler (age 1-3)',
  },
  [ChildCareAgeGroups.PRESCHOOLERS]: {
    value: ChildCareAgeGroups.PRESCHOOLERS,
    optionText: 'Preschool (age 4-5)',
  },
  [ChildCareAgeGroups.GRADE_SCHOOL_AGE]: {
    value: ChildCareAgeGroups.GRADE_SCHOOL_AGE,
    optionText: 'Elementary (age 6-10)',
  },
  [ChildCareAgeGroups.PRE_TEEN_TEENAGERS]: {
    value: ChildCareAgeGroups.PRE_TEEN_TEENAGERS,
    optionText: 'Middle school (ages 11+)',
  },
};

const childCareAgeGroupsToggleTokenOptions: AgeGroupToggleTokenDetail[] = [
  {
    type: ChildCareAgeGroups.FIRST_YEAR,
    formattedText: `Infant <br /> (age 0-11 months)`,
    icon: InfantIcon,
  },
  {
    type: ChildCareAgeGroups.TODDLERS,
    formattedText: 'Toddler <br /> (age 1-3)',
    icon: ToddlerIcon,
  },
  {
    type: ChildCareAgeGroups.PRESCHOOLERS,
    formattedText: 'Preschool <br /> (age 4-5)',
    icon: PreschoolIcon,
  },
  {
    type: ChildCareAgeGroups.GRADE_SCHOOL_AGE,
    formattedText: 'Elementary <br /> (age 6-10)',
    icon: ElementaryIcon,
  },
  {
    type: ChildCareAgeGroups.PRE_TEEN_TEENAGERS,
    formattedText: 'Pre-teens & Teens <br /> (age 11+)',
    icon: MiddleSchoolIcon,
  },
];

const companionCareAgeGroupsOptions: CompanionCareAgeGroupsOptions = {
  [CompanionCareAgeGroups.UNDER_55]: {
    value: CompanionCareAgeGroups.UNDER_55,
    optionText: 'Under 55 years old',
  },
  [CompanionCareAgeGroups.FROM_55_TO_64]: {
    value: CompanionCareAgeGroups.FROM_55_TO_64,
    optionText: '55 to 64 years old',
  },
  [CompanionCareAgeGroups.FROM_65_TO_74]: {
    value: CompanionCareAgeGroups.FROM_65_TO_74,
    optionText: '65 to 74 years old',
  },
  [CompanionCareAgeGroups.FROM_75_TO_84]: {
    value: CompanionCareAgeGroups.FROM_75_TO_84,
    optionText: '75 to 84 years old',
  },
  [CompanionCareAgeGroups.OVER_85]: {
    value: CompanionCareAgeGroups.OVER_85,
    optionText: 'Over 85 years old',
  },
};

export { childCareAgeGroupsOptions, companionCareAgeGroupsOptions, childCareAgeGroupsToggleTokenOptions };
